export const uploadFiles = (file, filename, successFunction) => {
  const csrf = document.querySelector("meta[name='csrf-token']").getAttribute('content');

  let formData = new FormData();
  formData.append('file', file);
  formData.append('filename', filename);

  fetch(`/api/v1/upload_files`, {
    method: 'POST',
    headers: {
      'X-CSRF-Token': csrf,
    },
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      successFunction(data);
    });
};
